
export enum LOGICAL_OPERATOR {
  OR = 'OR',
  AND = 'AND'
}


export enum OPERATION {
  IN = 'IN',
  EQUALS = 'EQUALS',
  CONTAINS = 'CONTAINS'
}

